import { GetListParams } from 'react-admin';

import {
  CustomDataProvider,
  registerModuleDataProvider,
} from 'src/pages/admin/providers/CustomDataProvider';
import {
  ListPendingRebalancesResponse,
  listPendingRebalances,
} from 'src/pages/admin/services/xbitRelayRebalancesService';

import { Resources } from '../../resource';
import { pickRebalanceFilters } from './helpers';

const resourceName = Resources.xbitRelayHotWalletBalancer;

export const xbitRelayRebalancesDataProvider: CustomDataProvider = {
  async getList(_resource: string, params: GetListParams): Promise<any> {
    const { page = 1, perPage = 20 } = params.pagination || {};

    const response = await listPendingRebalances({
      ...pickRebalanceFilters(params.filter),
      page,
      pageSize: perPage,
    });

    const { items = [], total } =
      response.data ?? ({} as Partial<ListPendingRebalancesResponse>);
    return {
      // `id` is a real UUID from the BE and is what :id needs — keep it untouched.
      data: items.map((item) => ({ ...item, id: item.id })),
      // `total` is an int64-as-string; react-admin needs a number.
      total: Number(total) || 0,
    };
  },
};

registerModuleDataProvider(resourceName, xbitRelayRebalancesDataProvider);
